export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8910.00f9c9ff.jpg";